import styled from 'styled-components';

import { Skeleton } from '~/src/common/components/Skeleton/Skeleton';
import { media } from '~/src/common/theme/deprecated';
import { ProductGridArea } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/constants';

import * as Original from '../../layout';
export { Root, Content, Grid } from '../../layout';

export const Caroussel = styled.div`
  grid-area: ${ProductGridArea.Gallery};
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow: hidden;

  & > * {
    flex-shrink: 0;
  }
`;

export const Thumbnail = styled(Skeleton)`
  display: none;

  ${media.S`
    display: block;
  `}
`;

export const PrimaryInformation = styled.div`
  grid-area: ${ProductGridArea.PrimaryInfos};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Picker = styled.div`
  grid-area: ${ProductGridArea.Picker};
  display: none;

  ${media.M`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    ${Original.AsideBlock}
  `}
`;

export const SecondaryInformation = styled.div`
  grid-area: ${ProductGridArea.SecondaryInfos};
  display: flex;
  gap: 16px;
  ${Original.AsideBlock}
`;

export const ShortDescription = styled.div`
  grid-area: ${ProductGridArea.ShortDescription};
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${Original.AsideBlock}

  div:last-child {
    align-self: flex-end;
  }
`;

export const ProductInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AdditionalInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  ${media.M`
    width: calc(100% - 450px);
  `}
`;
